<template lang="pug">
  .header__title.animated
    img(:src="slogan" alt="slogan")
</template>

<script>
import anime from 'animejs'
import { mapState } from 'vuex'

export default {
  name: 'HeaderTitle',
  computed: {
    ...mapState('siteVersions', {
      countryCode: state => state.item.code
    }),
    title: function () {
      return (this.countryCode === 'ar' && this.$i18n.locale === 'en') ? 'header.title_uae' : 'header.title'
    },
    slogan: function () {
      return (this.countryCode === 'ru' && this.$i18n.locale === 'ru')
        ? require(`@/assets/img/header/slogan_ru.svg`)
        : require(`@/assets/img/header/slogan.png`)
    }
  },
  mounted () {
    this.$nextTick(() => {
      anime.timeline()
        .add({
          targets: this.$el,
          opacity: [0, 1],
          scale: [0.2, 1],
          duration: 200,
          delay: 2200,
          easing: 'linear'
        })
        .add({
          targets: this.$refs.stroke,
          opacity: [1, 1],
          width: [0, '100%'],
          duration: 400,
          easing: 'linear'
        })
    })
  }
}
</script>
